import { render, staticRenderFns } from "./ElementMaxTableColumn.vue?vue&type=template&id=ec6d2e3c&scoped=true"
import script from "./ElementMaxTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementMaxTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementMaxTableColumn.vue?vue&type=style&index=0&id=ec6d2e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6d2e3c",
  null
  
)

export default component.exports